import React, { Component } from 'react';
import Promise from 'bluebird';
//import PropTypes from 'prop-types';
import styled from 'styled-components';
import CircularProgress from 'material-ui/CircularProgress';
import TextField from 'material-ui/TextField';
import { RaisedButton, IconButton, Snackbar } from 'material-ui';
import Prev from 'material-ui/svg-icons/hardware/keyboard-arrow-left';
import Next from 'material-ui/svg-icons/hardware/keyboard-arrow-right';
import Edit from 'material-ui/svg-icons/image/edit';
import Delete from 'material-ui/svg-icons/action/delete';
import config from 'cfg';

const Content = styled.div`
    padding-bottom: 30px;

    h2 {
        text-transfotm: capitalize;
    }
`;

const Loader = styled.div`
    text-align: center;
    display: flex;
    height: calc(100% - 284px);
    > * {
        margin: auto;
    }
`;

const Table = styled.table`
    width: 100%;
    text-align: left;
    border-collapse: collapse;
    border-spacing: 0;

    thead {
        font-weight: bold;
    }

    tbody {
        font-weight: 400;
    }

    th,
    td {
        border: 1px solid #ccc;
    }

    th {
        padding: 14px 20px;
    }

    td {
        padding: 10px 20px;
        font-size: 14px;

        &.tif_btns {
            > div {
                display: flex;
                justify-content: space-between;

                span {
                    display: inline-block;
                    position: relative;

                    &:nth-child(1):after {
                        content: '';
                        display: inline-block;
                        width: 1px;
                        height: 25px;
                        background-color: #ccc;
                        position: absolute;
                        top: 50%;
                        right: 0;
                        transform: translate(10px, -50%);
                    }
                }
            }
        }
    }
`;

const Field = styled.div`
    margin-bottom: 30px;
    display: flex;
    align-items: center;
`;

const Navs = styled.div`
    padding: 30px 0;
    display: flex;
    max-width: 60px;
    justify-content: space-between;
    align-items: center;
`;

class ProviderIds extends Component {
    state = {
        limit: 20,
        skip: 0,
        searchValue: null,
        preparedDataObject: {
            source: this.props.params.source
        },
        snackBarText: '',
        edit: false,
        dataLoading: true
    };

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        const { source } = this.props.params;
        const { limit, skip, searchValue } = this.state;

        const query = searchValue ? `&search=${searchValue}` : '';

        //config.apis.ss2 = 'http://127.0.0.1:3010';

        Promise.props({
            records: fetch(
                `${
                    config.apis.ss2
                }/admin/mapping?source=${source}&limit=${limit}&skip=${skip}&arr=${Math.random()}${query}`
            ).then(res => res.json())
        }).then(res => {
            this.setState({
                records: res.records.data,
                dataLength: res.records.dataLength,
                dataLoading: false
            });
        });
    }

    renderSearchField() {
        return (
            <Field>
                <TextField floatingLabelText="Search:" onChange={this.handleInputChange} />
            </Field>
        );
    }

    renderTable() {
        const { records } = this.state;
        const head = ['_id', 'Ext Id', 'Ext Name', 'Enet Id', 'Enet Name', 'Source', ''];

        return (
            <Table>
                <thead>
                    <tr>{head.map(name => <th key={name}>{name}</th>)}</tr>
                </thead>
                <tbody>
                    {records.map(team => {
                        return (
                            <tr key={`${team._id}`}>
                                <td>{team._id}</td>
                                <td>{team.extParticipantId || '-'}</td>
                                <td>{team.extParticipantName || '-'}</td>
                                <td>{team.enetParticipantId || '-'}</td>
                                <td>{team.enetParticipantName || '-'}</td>
                                <td>{team.source}</td>
                                <td className="tif_btns">
                                    <div>
                                        <span>
                                            <IconButton
                                                onClick={this.handleDelBtnClick(team._id)}
                                                tooltip="Delete"
                                                tooltipPosition="top-right"
                                            >
                                                <Delete />
                                            </IconButton>
                                        </span>
                                        <span>
                                            <IconButton
                                                onClick={this.handleEditClick(team)}
                                                tooltip="Edit"
                                                tooltipPosition="top-right"
                                            >
                                                <Edit />
                                            </IconButton>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        );
    }

    renderFields() {
        const { preparedDataObject, edit } = this.state;
        const { source } = this.props.params;
        const inputs = [
            {
                name: 'ext id',
                value: 'extParticipantId'
            },
            {
                name: 'ext name',
                value: 'extParticipantName'
            },
            {
                name: 'enet id',
                value: 'enetParticipantId'
            },
            {
                name: 'enet name',
                value: 'enetParticipantName'
            },
            {
                name: 'extra',
                value: 'extra'
            },
            {
                name: 'source',
                value: 'source',
                source: source
            }
        ];

        return (
            <Field>
                {inputs.map(field => {
                    return (
                        <TextField
                            key={field.value}
                            value={field.source ? field.source : preparedDataObject[field.value]}
                            //value={preparedDataObject[field.value]}
                            floatingLabelText={field.name}
                            onChange={this.handlePostInputChange(field.value)}
                            style={{ marginRight: '10px' }}
                        />
                    );
                })}

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <RaisedButton
                        onClick={this.handleEventBtnClick}
                        label={!edit ? 'Add' : 'Replace'}
                        style={{ margin: '2px 0' }}
                    />
                </div>
            </Field>
        );
    }

    renderPagination() {
        const { skip, limit, dataLength } = this.state;
        const isPrev = skip !== 0;
        const isNext = skip < dataLength - limit;

        return (
            <Navs>
                <IconButton disabled={!isPrev} onClick={this.handlePrevClick}>
                    <Prev />
                </IconButton>
                <IconButton disabled={!isNext} onClick={this.handleNextClick}>
                    <Next />
                </IconButton>
                {skip + 1}-{Math.min(skip + limit, dataLength)}
            </Navs>
        );
    }

    handleInputChange = ev => {
        this.setState(
            {
                searchValue: ev.target.value
            },
            () => {
                this.loadData();
            }
        );
    };

    handlePrevClick = () => {
        const { skip, limit } = this.state;

        this.setState(
            {
                skip: skip <= 0 ? 0 : skip - limit
            },
            () => {
                this.loadData();
            }
        );
    };

    handleNextClick = () => {
        const { skip, dataLength, limit } = this.state;

        this.setState(
            {
                skip: skip < dataLength - limit ? skip + limit : skip
            },
            () => {
                this.loadData();
            }
        );
    };

    handleEventBtnClick = () => {
        const { preparedDataObject, edit } = this.state;
        const defaultDataObject = {
            extParticipantId: '',
            extParticipantName: '',
            enetParticipantId: '',
            enetParticipantName: '',
            extra: ''
        };

        //config.apis.ss2 = 'http://127.0.0.1:3010';

        //PUT
        if (edit) {
            return fetch(`${config.apis.ss2}/admin/mapping`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(preparedDataObject)
            })
                .then(res => {
                    const { status } = res;
                    if (status === 200) {
                        return res.json();
                    } else {
                        throw new Error(`Error load status ${status}`);
                    }
                })
                .then(() => {
                    this.setState({
                        edit: false,
                        preparedDataObject: { ...this.state.preparedDataObject, ...defaultDataObject }
                    });

                    this.loadData();
                    this.showSnackBar('Data was replaced');
                })
                .catch(e => {
                    this.showSnackBar('Error while updating');
                    console.error(e);
                });
        }

        //POST
        return fetch(`${config.apis.ss2}/admin/mapping`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(preparedDataObject)
        })
            .then(res => {
                const { status } = res;
                if (status !== 200) throw new Error(`Error load status ${status}`);

                // if (status === 200) {
                //     return res.json();
                // } else {
                //     throw new Error(`Error load status ${status}`);
                // }
            })
            .then(() => {
                this.setState({
                    edit: false,
                    preparedDataObject: { ...this.state.preparedDataObject, ...defaultDataObject }
                });

                this.loadData();
                this.showSnackBar('Data was added');
            })
            .catch(e => {
                this.showSnackBar('Error while updating');
                console.error(e);
            });
    };

    //DELETE
    handleDelBtnClick = id => () => {
        return fetch(`${config.apis.ss2}/admin/mapping/${id}`, {
            method: 'DELETE'
        })
            .then(res => {
                const { status } = res;
                if (status === 200) {
                    this.loadData();
                    this.showSnackBar('Data was deleted');
                } else {
                    throw new Error(`Error load status: ${status}`);
                }
            })
            .catch(e => {
                this.showSnackBar('Error while updating');
                console.error(e);
            });
    };

    handlePostInputChange = key => ev => {
        const isId = key === 'enetParticipantId' || key === 'extParticipantId';

        this.setState({
            preparedDataObject: {
                ...this.state.preparedDataObject,
                [key]: isId && ev.target.value.length ? +ev.target.value : ev.target.value
            }
        });
    };

    handleEditClick = obj => () => {
        this.setState({
            preparedDataObject: obj,
            edit: true
        });
    };

    showSnackBar = text => {
        this.setState({ snackBarText: text });

        setTimeout(() => {
            this.setState({ snackBarText: '' });
        }, 3 * 1000);
    };

    render() {
        const { source } = this.props.params;
        const { records, dataLoading, snackBarText } = this.state;

        if (!records) return <div />;

        if (dataLoading)
            return (
                <Loader>
                    <CircularProgress />
                </Loader>
            );

        return (
            <Content>
                <h2>Source: {source}</h2>
                {this.renderSearchField()}
                {this.renderTable()}
                {this.renderPagination()}
                {this.renderFields()}
                <Snackbar open={Boolean(snackBarText)} message={snackBarText} style={{ textAlign: 'center' }} />
            </Content>
        );
    }
}

ProviderIds.propTypes = {
    //source: PropTypes.object.isRequired
};

export default ProviderIds;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/provider-ids/ProviderIds.js
 **/